import { render, staticRenderFns } from "./OauthGithub.vue?vue&type=template&id=3c5645dd&scoped=true&"
import script from "./OauthGithub.vue?vue&type=script&lang=js&"
export * from "./OauthGithub.vue?vue&type=script&lang=js&"
import style0 from "./OauthGithub.vue?vue&type=style&index=0&id=3c5645dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5645dd",
  null
  
)

export default component.exports